// extracted by mini-css-extract-plugin
export default {"wrapper":"SlackButton_wrapper__NDUIb","text":"SlackButton_text__XlZ6Z"};